<template>
  <div>
    <v-card color="#F6F8FC" flat class="px-5">
      <v-form v-model="valid" class="py-8">
        <v-card style="width: 8.7vw; padding: 1%" flat color="transparent">
          <userimageuploader-component />
        </v-card>

        <v-container class="mt-4">
          <v-text-field
            v-model="firstname"
            label="First name"
            required
          ></v-text-field>
          <v-text-field
            v-model="lastname"
            label="Last name"
            required
          ></v-text-field>
          <v-text-field
            v-model="PhoneNumber"
            label="Phone number"
            required
          ></v-text-field>

          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="Email address"
            required
          ></v-text-field>
        </v-container>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import UserimageuploaderComponent from "./userimageuploader.component.vue";
// import VueDropify from "vue-dropify";
// import vue2Dropzone from "vue2-dropzone";
// import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  name: "editteamcomponent",
  components: {
    UserimageuploaderComponent,
    // VueDropify,
    // vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200,
        addRemoveLinks: true,
      },
      valid: false,
      firstname: "",
      lastname: "",
      PhoneNumber: "",
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      role: ["super admin", "admin"],
    };
  },
  methods: {},
};
</script>

<style scoped>
.vue-dropzone {
  padding: 0;
  background: transparent;
  border-style: dashed;
}
</style>
